import React, { useRef } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Radio from '@mui/material/Radio';
import './fileUpload.css';
import { Button, FormHelperText } from '@mui/material';
import { useForm, Controller } from 'react-hook-form';

interface FileUploadProps {
    onClose: () => void;
    handlFileDetails: (params: any) => void
}

const FileUpload = (props: FileUploadProps) => {
    const { control, handleSubmit, setError, setValue, clearErrors, formState: { errors } } = useForm();
    console.log(errors, "Errors");

    const formSchema = [
        { label: 'Emirates ID', value: false },
        { label: 'SPA', value: true }
    ];

    const [fileTypeValue, setFileTypeValue] = React.useState('');
    const [selectedFile, setSelectedFile] = React.useState<File | null>(null);

    const fileInputRef = useRef<HTMLInputElement>(null);

    const triggerFileInput = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files.length > 0) {
            const file = event.target.files[0];
            setSelectedFile(file);
            setValue('file', file)
        }
    };

    console.log(selectedFile, 'Selected File ', fileTypeValue, 'Value');

    const onSubmit = (data: any) => {
        const fileTypeBoolean: boolean = data.fileType === 'true';
        data['fileType'] = fileTypeBoolean
        props.handlFileDetails(data)
    };

    return (
        <>
            <div className='modal-heading'>
                <h4>File Details</h4>
                <CloseIcon className='modal-close-button' onClick={() => { props.onClose() }} />
            </div>
            <div className='modal-body'>
                <div className='container-100'>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className='field-container'>
                            <FormControl component="fieldset" error={!!errors.fileType} required>
                                <FormLabel id="demo-controlled-radio-buttons-group" className='form-label'>File Type</FormLabel>

                                <Controller
                                    name="fileType"
                                    control={control}
                                    defaultValue=""
                                    rules={{ required: 'Please select a file type' }}
                                    render={({ field }) => (
                                        <RadioGroup {...field} onChange={(event) => {
                                            field.onChange(event.target.value);
                                            setFileTypeValue(event.target.value);
                                        }}>
                                            <div style={{ display: 'flex' }}>
                                                {formSchema.map((fieldOption, index) => (
                                                    <FormControlLabel
                                                        key={index}
                                                        value={fieldOption.value}
                                                        control={<Radio sx={{ transform: 'scale(0.6)' }} />}
                                                        label={fieldOption.label}
                                                        className='custom-label'
                                                    />
                                                ))}
                                            </div>
                                        </RadioGroup>
                                    )}
                                />

                                {errors.fileType && <FormHelperText error style={{ marginLeft: '2px' }} className='error-field'>{String(errors.fileType.message)}</FormHelperText>}
                            </FormControl>

                            <div className='file-input-button-wrapper'>
                                <div className='file-input-container'>
                                    <Button variant="outlined" component="span" sx={{ width: '100%' }} onClick={triggerFileInput}>
                                        {selectedFile ? (
                                            <div
                                                style={{
                                                    width: '100%',
                                                    display: 'block',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    whiteSpace: 'nowrap',
                                                    maxWidth: '100%',
                                                }}
                                            >
                                                {selectedFile.name}
                                            </div>
                                        ) : (
                                            <span>
                                                Select File
                                                <span className={errors.file ? 'error-text' : ''}>*</span>
                                            </span>
                                        )}
                                    </Button>
                                    <Controller
                                        name="file"
                                        control={control}
                                        rules={{ required: 'Please select a file' }}
                                        render={({ field }) => (
                                            <input
                                                type='file'
                                                ref={fileInputRef}
                                                style={{ display: 'none' }}
                                                onChange={(e) => {
                                                    field.onChange(e);
                                                    handleFileUpload(e);
                                                    if (e.target.files?.length === 0) {
                                                        setError('file', { message: 'Please select a file' });
                                                    } else {
                                                        clearErrors('file');
                                                    }
                                                }}
                                            />
                                        )}
                                    />

                                </div>
                                <div className='button-container'>
                                    <Button variant='contained' type='submit' style={{ width: '100%' }}>Upload</Button>
                                </div>

                            </div>
                            {errors.file && <FormHelperText error className='error-field'>{String(errors.file.message)}</FormHelperText>}
                        </div>


                    </form>
                </div >
            </div >
        </>
    );
}

export default FileUpload;
